<template>
  <custom-dialog class="location-item-dialog" :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" :validate-on-rule-change="false">
        <el-row>
          <el-col>
            <el-form-item :label="$t('Common.com_location_name')" prop="locationName">
              <el-input v-model="form.locationName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$t('Common.com_belong_to_department')" prop="departmentId" :rules="rules.departmentId">
            <custom-select
              url="DepartmentTree"
              v-model="form.departmentId"
              :props="{ label: 'bizName', value: 'bizId' }"
              :params="{ isCountDevice: 1 }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
              ref="tag"
              type="tree"
              filterable
              :dataFilter="departmentTreeFilter"
            ></custom-select>
          </el-form-item>
        </el-row>
        <!-- <el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="标签" prop="tagId" :rules="rules.tagId">
                <custom-select
                  url="locationTagList"
                  :listener="`${userInfo.rootOrgId}`"
                  v-model="form.tagId"
                  :props="{ label: 'tagName', value: 'tagId' }"
                  :params="{ orgId: userInfo.rootOrgId }"
                  placeholder="请选择"
                  width="100%"
                  ref="tag"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <el-button  type="warning" round style="width: 100%" @click="addTag">新增标签</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row> -->
        <el-row>
          <el-col>
            <el-form-item :label="$t('location_item_dialog.xiang_mu_lian_xi_ren')" prop="contactName">
              <el-input v-model="form.contactName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('location_item_dialog.lian_xi_ren_dian_hua')" prop="contactPhone">
              <el-input v-model="form.contactPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('location_item_dialog.zdszmb')" prop="isBasicGoal">
              <el-radio v-model="form.isBasicGoal" :label="1">{{ getDicValue('isynergy_cloud_bool', '1') }}</el-radio>
              <el-radio v-model="form.isBasicGoal" :label="0">{{ getDicValue('isynergy_cloud_bool', '0') }}</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('location_item_dialog.xiang_mu_di_zhi')">
              <custom-address-select placeholder="" v-model="form.address" ref="address"></custom-address-select>
              <el-input v-model="form.detailAddress" type="textarea" :rows="2" class="detail-address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item key="timeZoneId" :label="$t('location_item_dialog.mo_ren_shi_qu')" prop="timeZoneId" v-if="timeZoneList.length > 1">
              <custom-select
                v-model="form.timeZoneId"
                :data="timeZoneList"
                :auto="false"
                :clearable="false"
                :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" plain @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <location-tag-dialog v-if="dialogVisible" :model="dialogModel" @success="getTagsList"></location-tag-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import customAddressSelect from '@/components/customAddressSelect.vue';
import dialogMixins from '@/mixins/dialog_mixins';
import locationTagDialog from './location_tag_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    customAddressSelect,
    locationTagDialog,
  },
  computed: {
    rules() {
      return {
        locationName: [
          { max: 50, message: this.$t('location_item_dialog.cdbncg50gzf') },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        contactName: [
          {
            max: 30,
            message: this.$t('location_item_dialog.cdbncg30gzf'),
          },
        ],
        contactPhone: [
          {
            max: 20,
            message: this.$t('location_item_dialog.cdbncg20gzf'),
          },
        ],
      };
    },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // 项目名称
        locationName: '',
        // 负责人
        contactName: '',
        // 负责人电话
        contactPhone: '',
        // 项目地址（省市区）,
        address: [],
        // 详细地址
        detailAddress: '',
        // 项目备注
        lat: '',
        lng: '',
        locationId: '',
        orgId: '',
        orgName: '',
        tagId: '',
        departmentId: '', // 所属部门
        isBasicGoal: 1,
        timeZoneId: '',
      },
      timeZoneList: [],
      props: {
        label: 'name',
        value: 'nationRegionId',
      },
      dialogVisible: false,
      dialogModel: {},
    };
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    closeDialog() {
      this.visible = false;
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    onConfirm() {
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);
        if (val) {
          const reqData = this.getEditReqData();
          if (this.timeZoneList.length > 0) {
            reqData.timeZoneId = this.timeZoneList[0].timeZoneId;
          }
          this.$postJSON(apis.locationUpdate, reqData, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success', this.form);
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          const reqData = this.getAddReqData();
          this.$postJSON(apis.locationAdd, reqData, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.$emit('success', this.form);
          });
        }
      });
    },
    getAddReqData() {
      const addressMsg = this.$refs.address.getAddressMsg();
      return {
        ...addressMsg,
        detailAddress: this.form.detailAddress,
        lat: this.form.lat,
        lng: this.form.lng,
        locationId: this.form.locationId,
        locationName: this.form.locationName,
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
        tagId: this.form.tagId,
        isBasicGoal: this.form.isBasicGoal,
        departmentId: Array.isArray(this.form.departmentId)
          ? this.form.departmentId.slice(-1)[0] // 如果是数组取最后一项
          : this.form.departmentId, // 非数组直接使用原值
        timeZoneId: this.form.timeZoneId
      };
    },
    getEditReqData() {
      return this.getAddReqData();
    },
    companyAddressDataFilter(list) {
      list.forEach((country) => {
        (country.children || []).forEach((province) => {
          (province.children || []).forEach((city) => {
            city.children = null;
          });
        });
      });
      return list;
    },
    handleInputConfirm() {
      const specialWord = [','];
      if (this.inputValue && this.inputValue.trim()) {
        if (specialWord.includes(this.inputValue)) {
          const tips = this.$t('location_item_dialog.byxtszf');
          this.$message.error(tips);
          return;
        }
        if (!this.tags.includes(this.inputValue)) {
          // computed 的tags不能用push，push无法触发set方法
          this.tags = [...this.tags, this.inputValue];
          this.inputVisible = false;
          this.inputValue = '';
        } else {
          const tips = this.$t('location_item_dialog.byxxtbq');
          this.$message.error(tips);
        }
      } else {
        const tips = this.$t('location_item_dialog.bu_yun_xu_wei_kong');
        this.$message.error(tips);
      }
    },
    showInput() {
      this.inputVisible = true;
    },

    handleClose(tag) {
      const newTags = this.tags.filter(item => `${item}` !== `${tag}`);
      this.tags = newTags;
    },
    addTag() {
      this.dialogModel.title = this.$t('location_item_dialog.xin_zeng_biao_qian');
      this.dialogModel.type = 'add';
      this.dialogModel.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
      };
      this.dialogVisible = true;
    },
    getTagsList() {
      this.dialogVisible = false;
      this.$refs.tag.getSelectList();
    },
    getProjectInfo() {
      this.$getJSON(apis.locationInfo, { locationId: this.model.id }).then((res) => {
        const data = res.data || {};
        // console.log(this.model.data);
        this.$setFormatData(this.form, data);
        this.form.isBasicGoal = Number(data.isBasicGoal);
        this.form.contactPhone = '';
        // 地址
        this.form.address = [];
        if (data.countryCode) {
          this.form.address.push(data.countryCode);
        }
        if (data.provinceCode) {
          this.form.address.push(data.provinceCode);
        }
        if (data.cityCode) {
          this.form.address.push(data.cityCode);
        }
      });
    },
    initForm() {
      if (this.model.type === 'add') {
        this.getTimeZoneList(true);
        return;
      }
      this.getProjectInfo();
      this.getTimeZoneList(false);
    },
  },
  mounted() {
    this.initForm();

    // this.getLanguage();
  },
};
</script>

<style lang="scss">
.location-item-dialog {
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
}
</style>
